import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Feed.svg",
  "use": "Feed.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Feed.svg\"><path d=\"M49.0208,54.0208h-34a5,5,0,0,1-5-5v-34a5,5,0,0,1,5-5h34a5,5,0,0,1,5,5v34A5,5,0,0,1,49.0208,54.0208Zm-27-39a1,1,0,0,0-1-1h-6a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1Zm27,0h-22a1,1,0,1,0,0,2h22a1,1,0,1,0,0-2Zm-23,5a1,1,0,0,0,1,1h14a1,1,0,1,0,0-2h-14A1,1,0,0,0,26.0208,20.0209Zm24,7a1,1,0,0,0-1-1h-34a1,1,0,0,0-1,1v22a1,1,0,0,0,1,1h34a1,1,0,0,0,1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol